import {isSsr} from '@ui/utils/dom/is-ssr';

interface UseAppearanceEditorModeResult {
  isAppearanceEditorActive: boolean;
  appearanceEditorParams: Record<string, string>;
}

export function useAppearanceEditorMode(): UseAppearanceEditorModeResult {
  // SSR (Konu 1): `isSsr()` / window kontrolü, window'a DOKUNMADAN önce yapılmalı
  // (eskiden window.frameElement ilk satırdaydı → Node'da crash; SSR hiç
  // koşulmadığı için gizli kalmıştı).
  if (isSsr() || typeof window === 'undefined') {
    return {
      isAppearanceEditorActive: false,
      appearanceEditorParams: {},
    };
  }

  const iframe = (window.frameElement as HTMLIFrameElement) || undefined;

  if (!iframe?.src) {
    return {
      isAppearanceEditorActive: false,
      appearanceEditorParams: {},
    };
  }

  const search = new URL(iframe.src).searchParams;

  return {
    isAppearanceEditorActive: search.get('appearanceEditor') === 'true',
    appearanceEditorParams: Object.fromEntries(search),
  };
}
